import { useMemo } from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

export default function CustomPagination({ pagina, paginas, onChange }) {

  const items = useMemo(() => {
    return new Array(paginas).fill(null).map((el, i) => i + 1)
  }, [paginas])

  const handleClick = novaPagina => e => {
    e.preventDefault()

    if (pagina != novaPagina) {
      onChange && onChange(novaPagina)
    }
  }

  return (
    <nav aria-label="...">
      <Pagination
        className="pagination justify-content-end mb-0"
        listClassName="justify-content-end mb-0"
      >
        <PaginationItem className={pagina == 1 ? "disabled" : null}>
          <PaginationLink
            href="/"
            onClick={handleClick(pagina - 1)}
            tabIndex="-1"
          >
            <i className="fas fa-angle-left" />
            <span className="sr-only">Anterior</span>
          </PaginationLink>
        </PaginationItem>


        {items.map(el => (
          <PaginationItem className={pagina == el ? "active" : null} key={el}>
            <PaginationLink
              href="/"
              onClick={handleClick(el)}
            >
              {el}
            </PaginationLink>
          </PaginationItem>
        ))}

        <PaginationItem className={pagina == paginas ? "disabled" : null}>
          <PaginationLink
            href="/"
            onClick={handleClick(pagina + 1)}
          >
            <i className="fas fa-angle-right" />
            <span className="sr-only">Próxima</span>
          </PaginationLink>
        </PaginationItem>
      </Pagination>
    </nav>
  )
}